import React, { memo } from 'react';
import { BasicClearIcon } from '../icons/basic-clear-icon';
export var ClearIcon = memo(function () { return React.createElement(BasicClearIcon, { colorType: "greyColor" }); });
